import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AccreditionsListComponent } from './accreditions-list/accreditions-list.component';
import { AccreditionsCreateComponent } from './accreditions-create/accreditions-create.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list',
        component: AccreditionsListComponent,
        data: {
          title: "Accreditions List",
          breadcrumb: "Accreditions List"
        }
      },
      {
        path: 'create',
        component: AccreditionsCreateComponent,
        data: {
          title: "Create Accreditions",
          breadcrumb: "Create Accreditions"
        }
      },
      {
        path: 'edit/:id',
        component: AccreditionsCreateComponent,
        data: {
          title: "Edit Accreditions",
          breadcrumb: "Edit Accreditions"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class AccreditionsRoutingModule { }
